<span class="p-float-label w-full">
  <jml-lib-rich-text-editor
    #editor
    [formControl]="control"
    [height]="height"
    [mandatory]="mandatory"
    [showSaveButton]="false"
    (blur)="handleBlur()"
    (focus)="handleFocus()"
  >
  </jml-lib-rich-text-editor>

  <label *ngIf="placeholder">{{ placeholder }}</label>
</span>
